import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import or from 'ember-truth-helpers/helpers/or';
import BvBtn from 'volta/components/bv-btn';
import BaseCell from 'volta/components/cell/base-cell';
import orElse from 'volta/helpers/or-else';
import type { TOC } from '@ember/component/template-only';
import type { CellBaseCellSignature } from 'volta/components/cell/base-cell';
const CellActionCellComponent: TOC<CellBaseCellSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='action-cell'
    as |cell|
  >
    {{#if cell.value.visible}}
      <BvBtn
        @iconLeft={{cell.value.icon}}
        @iconRight={{cell.value.iconRight}}
        @onClick={{fn (optional cell.value.action) cell.value.model}}
        @subtle={{orElse cell.value.subtle true}}
        @color={{cell.value.color}}
        @size={{cell.value.size}}
        @text={{cell.value.text}}
        @rounded={{cell.value.rounded}}
        @disabled={{cell.value.disabled}}
        @outline={{cell.value.outline}}
        class={{cell.value.classNames}}
        title={{or cell.value.title cell.value.text}}
      />
    {{/if}}
  </BaseCell>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default CellActionCellComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'Cell::ActionCell': typeof CellActionCellComponent;
        'cell/action-cell': typeof CellActionCellComponent;
    }
}
